import request from '@/utils/request'

/**
 * 电子围栏
 * @param {*} data
 */
function getDtcReport(data) {
  return request({
    url: '/report/dtc/list',
    method: 'post',
    data
  })
}
/**
 * 导出
 * @param {*} data
 */
function exportDtc(data) {
    return request({
      url: '/report/dtc/report',
      method: 'post',
      responseType: 'arraybuffer',
      data
    })
  }

export {
    getDtcReport,
    exportDtc
  }
  